import AssigneesCell from "components/Cells/AssigneesCell";
import { OUTLINE_ITEM_ENTITY_TYPE } from "constants/entityTypes";
import { number, object, oneOfType, shape, string } from "prop-types";

import useAssigneeCascade from "../hooks/useAssigneeCascade";

const AssigneeCell = ({ row }) => {
  const { id, assignees } = row.original;

  const { onAssigneesChange, onBeforeCommit } = useAssigneeCascade(id);

  return (
    <AssigneesCell
      assignees={assignees}
      entityType={OUTLINE_ITEM_ENTITY_TYPE}
      entityId={id}
      onAssigneesChange={onAssigneesChange}
      onBeforeCommit={onBeforeCommit}
    />
  );
};

AssigneeCell.propTypes = {
  row: shape({
    id: oneOfType([number, string]),
    original: object,
  }),
};

export default AssigneeCell;
